import { render, staticRenderFns } from "./ExhibitionCard.vue?vue&type=template&id=1f3284ec&scoped=true"
import script from "./ExhibitionCard.vue?vue&type=script&lang=js"
export * from "./ExhibitionCard.vue?vue&type=script&lang=js"
import style0 from "./ExhibitionCard.vue?vue&type=style&index=0&id=1f3284ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3284ec",
  null
  
)

export default component.exports